import { FC, PropsWithChildren, useContext, useMemo, useState } from 'react';
import classnames from 'classnames';

import { AsyncDataContext, AsyncDataContextProps } from '@hh.ru/magritte-ui-date-picker/AsyncDataContext';
import { DateType } from '@hh.ru/magritte-ui-date-picker/types';
import { Loader } from '@hh.ru/magritte-ui-loader';

import styles from './date-picker.less';

/**
 * Отображает лоадер поверх контента во время загрузки асинхронных данных.
 * В multi-лейауте каждый календарь должен быть обернут в свой лоадер,
 * чтобы календари с уже загруженными данными рендерили их, а не анимацию лоадера
 */
export const AsyncDataLoader: FC<PropsWithChildren> = ({ children }) => {
    const asyncDataContext = useContext(AsyncDataContext);
    const [isLoading, setLoading] = useState(false);

    const value = useMemo<AsyncDataContextProps | null>(() => {
        if (!asyncDataContext) {
            return null;
        }

        return {
            ...asyncDataContext,
            startAsyncLoading: (startDate: DateType, endDate: DateType) => {
                setLoading(true);

                void (async () => {
                    try {
                        await asyncDataContext.awaitAsyncLoading(startDate, endDate);
                    } finally {
                        setLoading(false);
                    }
                })();
            },
        };
    }, [asyncDataContext, setLoading]);

    return (
        <div className={classnames(styles.datePicker, { [styles.datePickerLoading]: isLoading })} data-qa="date-picker">
            {isLoading && (
                <div className={styles.loader}>
                    <Loader />
                </div>
            )}
            <div className={classnames({ [styles.loading]: isLoading })}>
                <AsyncDataContext.Provider value={value}>{children}</AsyncDataContext.Provider>
            </div>
        </div>
    );
};
